import React from "react";
import { dateFormatter, getEventImageUrl } from "../../../utils/Helper";

const toPlainText = (value) => {
  if (!value) {
    return "";
  }
  return String(value)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const EventCard = ({ details }) => {
  if (!details?.name && !details?.image) {
    return null;
  }

  const categoryLabel = Array.isArray(details?.category)
    ? details.category
        .map((item) => item?.name || item)
        .filter(Boolean)
        .join(", ")
    : details?.category?.name || details?.category || "";

  const description = toPlainText(details?.description);
  const imagePath = details?.image?.[0]?.path || "";

  return (
    <article className="event-attendee-detail-event-card" aria-label="Event details">
      <div className="event-attendee-detail-event-image-wrap">
        <img
          className="event-attendee-detail-event-image"
          src={imagePath ? getEventImageUrl(imagePath) : ""}
          alt={details?.name || "Event"}
        />
      </div>
      <div className="event-attendee-detail-event-copy">
        <p className="event-attendee-detail-event-label">Event</p>
        <h3 className="event-attendee-detail-event-name">
          {details?.name || "—"}
        </h3>
        <p className="event-attendee-detail-event-date">
          <i className="bi bi-calendar3" aria-hidden="true"></i>
          <span>{details?.date ? dateFormatter(details.date) : "—"}</span>
        </p>
        {description && (
          <p className="event-attendee-detail-event-description">{description}</p>
        )}
        {categoryLabel && (
          <p className="event-attendee-detail-event-category">
            {String(categoryLabel)}
          </p>
        )}
      </div>
    </article>
  );
};

export default EventCard;
